import type { CompanyCustomerType } from "@repo/common";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "./ui/select";

export const CUSTOMER_TYPE_LABELS = {
	paying: "Paying customer",
	trial: "Trial customer",
	test: "Test customer",
	unclassified: "Unclassified",
} as const;

export function CustomerTypeSelect({
	id,
	value,
	onChange,
	disabled = false,
}: {
	id: string;
	value?: CompanyCustomerType | null;
	onChange: (value: CompanyCustomerType | null) => void;
	disabled?: boolean;
}) {
	return (
		<Select
			value={value ?? "unclassified"}
			disabled={disabled}
			onValueChange={(next) =>
				onChange(next === "unclassified" ? null : (next as CompanyCustomerType))
			}
		>
			<SelectTrigger id={id}>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{Object.entries(CUSTOMER_TYPE_LABELS).map(([key, label]) => (
					<SelectItem key={key} value={key}>
						{label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
